import React, { Component, Fragment } from 'react';
import SigninForm from '../components/SignIn/signin';
import { Navigate  } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import soapRequest from '../helpers/soapRequest';
import CryptoJS from 'crypto-js';
import { format } from 'date-fns';

class Signin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            confirmPassword: '',
            redirect: false,
            alert: false,
            alertMessage: '',
            alertType: '',
            buttonState: 'button',
            errorPassword: false,
            errorPasswordMessage: '',
            errorPasswordConfirmation: false,
            errorPasswordMessageConfirmation: '',
            openNewUser: false,
            changePasswordButtonDisabled: true,
            keyAES256: "e8b7b40e031300000000da2474412263",
            client: props.client
        }
        this.onChangeField = this.onChangeField.bind(this);
        this.onLogin = this.onLogin.bind(this);
        this.closeAlert = this.closeAlert.bind(this);
        this.getButton = this.getButton.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.onChangeFieldNewUser = this.onChangeFieldNewUser.bind(this);
        this.handleSaveNewPassword = this.handleSaveNewPassword.bind(this);
    }

    /**
     * Asigna valor escrito en campos de texto a los estados username y password
     * @param {String} field - Nombre del campo de texto
     * @param {String} value - Valor ingresado en el campo de texto
    */
    onChangeField(field, value) {
        this.setState({ [field]: value });
    }

    onChangeFieldNewUser(field, value) {
        this.setState({ [field]: value });
        var errorPassword = false;
        var errorPasswordMessage = ""
        switch (field) {
            case "password":
                errorPasswordMessage = (
                    ! /^\S*$/.test(value) ?
                        "Contraseña no puede contener espacios." :
                        ! /[A-Z]/.test(value) ?
                            "Contraseña debe contener al menos una mayuscula" :
                            value.length < 8 ?
                                "Contraseña debe tener al menos 8 caracteres" :
                                ! /^[a-zA-Z0-9!@#$%^&*]/.test(value) ?
                                    "Contraseña solo puede contener letras, números y caracteres especiales." :
                                    ""
                )

                errorPassword = errorPasswordMessage !== "" ? true : false;
                this.setState({
                    errorPassword: errorPassword,
                    errorPasswordMessage: errorPasswordMessage
                })
                break;
            case "confirmPassword":
                const { password } = this.state;
                if (value !== password) {
                    this.setState({
                        errorPasswordConfirmation: true,
                        errorPasswordMessageConfirmation: "Las contraseñas no coinciden."
                    });
                }
                else {
                    this.setState({
                        errorPasswordConfirmation: false,
                        errorPasswordMessageConfirmation: "",
                        changePasswordButtonDisabled: false,
                    });
                }
                break;
        }
    }

    /**
     * Desencadena al apretar botón de iniciar sesión.
     * Realiza una solicitud SOAP para verificar al usuario.
    */
    onLogin() {
        const { timeout } = this.props;
        const { username, password, keyAES256, client } = this.state;
        this.setState({ buttonState: 'loading' });
        const messageArray = [];
        let currentDate = format(new Date(), 'yyyy-MM-dd');
        let dKey = currentDate+'/'+currentDate+'G'+currentDate;
        var encryptedPassword = CryptoJS.AES.encrypt(password, keyAES256).toString();
        encryptedPassword = CryptoJS.AES.encrypt(encryptedPassword, dKey).toString();
        if (username != '' && password != '') {
            if (username === password) { //Posible usuario nuevo
                messageArray.push(
                    "<message>",
                    "<username>",
                    username,
                    "</username>",
                    "<password>",
                    encryptedPassword,
                    "</password>",
                    "<operation>",
                    2,
                    "</operation>",
                    "<clientName>",
                    client,
                    "</clientName>",
                    "</message>"
                );
                const message = messageArray.join("");
                //Revisa si es nuevo usuario
                soapRequest('validateLogin', timeout, message).then((result) => {
                    if (result.getElementsByTagName('id')[0].value !== '-1') { //Usuario nuevo
                        this.setState({
                            password: "",
                            openNewUser: true, //abre modal nueva contraseña
                            buttonState: 'button'
                        });
                    }
                    else { //Usuario que no existe o ya cambió contraseña
                        this.setState({
                            alert: true,
                            alertMessage: 'Error: Verifique su usuario y/o contraseña.',
                            alertType: 'error',
                            buttonState: 'button'
                        });
                    }
                });
            }
            else { //No es usuario nuevo
                messageArray.push(
                    "<message>",
                    "<username>",
                    username,
                    "</username>",
                    "<password>",
                    encryptedPassword,
                    "</password>",
                    "<operation>",
                    1,
                    "</operation>",
                    "<clientName>",
                    client,
                    "</clientName>",
                    "</message>"
                );
                const message = messageArray.join("");
                soapRequest('validateLogin', timeout, message).then((result) => {
                    if (result.getElementsByTagName('token')[0] != undefined) {
                        const token = result.getElementsByTagName('token')[0].value;
                        sessionStorage.setItem('userToken', token);
                        this.setState({ redirect: true });
                    }
                    else {
                        this.setState({
                            alert: true,
                            alertMessage: 'Error: Verifique su usuario y/o contraseña',
                            alertType: 'error',
                            buttonState: 'button'
                        });
                    }
                })
            }

        }
        else {
            this.setState({
                alert: true,
                alertMessage: 'Ingresa tu correo y contraseña',
                alertType: 'error',
                buttonState: 'button'
            });
        }

    }

    /**
     * Cierra mensaje de alerta
    */
    closeAlert() {
        this.setState({
            alert: false,
        });
    }

    /**
     * Obtiene el botón a mostrar.
     * @returns {Component} Componente spinner en caso de estar en espera de respuesta desde el servidor, o un componente botón en caso de que aún no se inicie sesión.
    */
    getButton() {
        return (
            this.state.buttonState === 'loading' ?
                <CircularProgress
                    size='30px'
                    color="primary"
                />
                :
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={this.onLogin}
                    type="submit"
                >
                    Iniciar sesión
                </Button>
        )
    }

    /**
     * Detecta cuando se presiona botón Enter para ejecutar función de onLogin.
     * @param {Event} event - Evento al apretar una tecla.
    */
    onKeyPress(event) {
        if (event.charCode === 13) { // tecla enter presionada
            event.preventDefault();
            this.onLogin();
        }
    }
    containsUppercase(str) {
        return /[A-Z]/.test(str);
    }
    /**
     * Llama a método que realiza solicitud para cambio de contraseña y vierra ventana de diálogo de cambio de contraseña para usuario nuevo
     */
    handleCloseDialog() {
        const { password } = this.state;
        if((password.length < 8) || (this.containsUppercase(password) === false) ){
            this.setState({
                alert: true,
                alertMessage: 'Error al intentar cambiar su contraseña.',
                alertType: 'error'
            })
        } else {
            this.handleSaveNewPassword();
        }
        this.setState({
            openNewUser: false, //Cierra ventana de diálogo
            username: "",
            password: "",
            buttonState: 'button',
            confirmPassword: "",
            changePasswordButtonDisabled: true,
        })
    }
    /**
     * Realiza solicitud al servidor para cambio de contraseña para usuario nuevo
    */
    handleSaveNewPassword() {
        const { timeout } = this.props;
        const { username, password, keyAES256, client } = this.state;
        const messageArray = [];
        let currentDate = format(new Date(), 'yyyy-MM-dd');
        let dKey = currentDate+'/'+currentDate+'G'+currentDate;
        var encryptedPassword = CryptoJS.AES.encrypt(password, keyAES256).toString();
        encryptedPassword = CryptoJS.AES.encrypt(encryptedPassword, dKey).toString();
        messageArray.push(
            "<message>",
            "<username>",
            username,
            "</username>",
            "<password>",
            encryptedPassword,
            "</password>",
            "<operation>",
            0,
            "</operation>",
            "<clientName>",
            client,
            "</clientName>",
            "</message>"
        );
        const message = messageArray.join("");
        //Solicitud al servidor para cambiar contraseña
        soapRequest('validateLogin', timeout, message).then((result) => {
            var alertMessage = '';
            var alertType = '';
            //Datos para alerta con respuesta desde server (Exitoso/Fallido)
            if (result.getElementsByTagName('id')[0].value !== '-1') {
                alertType = 'success';
                alertMessage = 'Su contraseña ha sido cambiada con éxito';
            }
            else {
                alertType = 'error';
                alertMessage = 'Error al intentar cambiar su contraseña.';
            }
            this.setState({
                alert: true,
                alertMessage: alertMessage,
                alertType: alertType
            })
        })
    }
    render() {
        const { theme } = this.props;
        const {
            username,
            password,
            confirmPassword,
            alert,
            alertMessage,
            alertType,
            errorPassword,
            errorPasswordMessage,
            errorPasswordConfirmation,
            errorPasswordMessageConfirmation,
            openNewUser,
            changePasswordButtonDisabled,
        } = this.state;
        if (sessionStorage.getItem('userToken')) {
            return (<Navigate  to={'/home'} />)
        }
        return (
            <SigninForm
                username={username}
                password={password}
                confirmPassword={confirmPassword}
                alert={alert}
                alertMessage={alertMessage}
                alertType={alertType}
                onChangeField={this.onChangeField}
                onLogin={this.onLogin}
                closeAlert={this.closeAlert}
                getButton={this.getButton}
                theme={theme}
                onKeyPress={this.onKeyPress}
                errorPassword={errorPassword}
                errorPasswordMessage={errorPasswordMessage}
                errorPasswordConfirmation={errorPasswordConfirmation}
                errorPasswordMessageConfirmation={errorPasswordMessageConfirmation}
                openNewUser={openNewUser}
                handleCloseDialog={this.handleCloseDialog}
                onChangeFieldNewUser={this.onChangeFieldNewUser}
                changePasswordButtonDisabled={changePasswordButtonDisabled}
            />
        );
    }
}

export default Signin;